"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useDragSourceHandler(sourceSpec) {
  var sourceSpecRef = react_1.useRef(sourceSpec);
  react_1.useEffect(function () {
    sourceSpecRef.current = sourceSpec;
  }); // Can't use createSourceFactory, as semantics are different

  var handler = react_1.useMemo(function () {
    return {
      beginDrag: function beginDrag(monitor, target) {
        var begin = sourceSpecRef.current.begin;
        return begin(monitor);
      },
      canDrag: function canDrag(monitor, target) {
        var canDrag = sourceSpecRef.current.canDrag;
        return canDrag ? canDrag(monitor) : true;
      },
      isDragging: function isDragging(monitor, target) {
        var isDragging = sourceSpecRef.current.isDragging;
        return isDragging ? isDragging(monitor) : target === monitor.getSourceId();
      },
      endDrag: function endDrag(monitor, target) {
        var end = sourceSpecRef.current.end;

        if (end) {
          end(monitor);
        }
      }
    };
  }, []);
  return handler;
}

exports.useDragSourceHandler = useDragSourceHandler;